/**
 * RetailerCardSkeleton - Loading state for retailer cards
 * 
 * Matches the exact layout of RetailerCard with shimmer animation
 */

import React from 'react';

export function RetailerCardSkeleton() {
  return (
    <div className="bg-white border-2 border-gray-200 rounded-xl p-6 animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-gray-200 rounded-lg" />
          <div className="w-32 h-6 bg-gray-300 rounded" />
        </div>
        <div className="w-5 h-5 bg-gray-200 rounded" />
      </div>

      {/* Revenue */}
      <div className="mb-6">
        <div className="w-20 h-4 bg-gray-200 rounded mb-2" />
        <div className="w-28 h-8 bg-gray-300 rounded" />
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-3 gap-4">
        {[1, 2, 3].map(i => (
          <div key={i}>
            <div className="w-16 h-3 bg-gray-200 rounded mb-2" />
            <div className="w-12 h-6 bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}

